export class DepotDetails {
  id: number = -1;

  depotId: number = -1;

  licenceNumber: string = '';
  carrierLicenceNumber: string = '';
  carrierLicenceExpiryDate: string = '';
  isOwn: boolean = false;

  createdAt: string = '';
  updatedAt: string = '';
}
